<template>
  <Layout>
    <div class="page-container">
      <div class="mc-list-header">
        <PageHeader :title="title" :subTitle="subTitle">
          <template #afterTitle>
            <McButton
              variant="secondary"
              class="ms-3"
              :text="$t('global.back')"
              icon="icon-outline_arrow-left"
              @click="$router.push({ name: 'Master Home Page' })"
            />
          </template>
        </PageHeader>
      </div>

      <McInlineFilter
        :filterItems="inlineFilterItems"
        :activeKeys="activeFilters['status.name']"
        @update:activeKeys="handleChangeActiveFilters([{ key: 'status.name', values: $event }])"
      />

      <McTable
        v-show="isTableDataAvailable"
        :fields="fields"
        :apiClient="apiClient"
        :activeFilters="activeFilters"
        :customHandlers="customHandlers"
        withCard
        searchable
        @available-change="handleDataAvailable"
        stickyHeader
        bulkDeleteApi
        hasEmit:deleteError
        @deleteError="handleDeleteError"
      >
        <template #cell(status.name)="{ value, item }">
          <span
            v-if="item.status?.color"
            class="__status-dots"
            :style="{ backgroundColor: item.status.color }"
          ></span>
          <span style="color: #344264">{{ value }}</span>
        </template>
        <template #cell(is_paired)="{ value }">
          <span v-if="value" style="color: #344264;"><i class="mc-fa fas fa-check"></i></span>
        </template>
      </McTable>

      <b-card v-show="!isTableDataAvailable">
        <div class="empty-table-container">
          <img src="@/assets/images/no-data-illustration.png" alt />
          <strong>Belum ada data vendor</strong>
          <p>Tambahkan data terlebih dulu ya!</p>
          <McButton
            variant="primary"
            :text="$t('global.addField')"
            icon="icon-outline_plus"
            @click="handleAdd"
          />
        </div>
      </b-card>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McTable from '@/components/McTable'
import McButton from '@/components/McButton'
import McInlineFilter from '@/components/McInlineFilter'
import * as Vendor from '@/services/rest-api/lib/vendor/vendor'

import listTableFields from './lib/fields/list-table-fields.js'
import inlineFilterItems from './lib/constants/inline-filter-items.js'
import { transformFilter } from './lib/helpers/transform-filter'
import { errorMessage } from '@/helpers/errorHandler'
import errorMessageList from './lib/constants/api-error-mappings'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Master Vendor',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McTable,
    McButton,
    McInlineFilter,
  },
  data() {
    return {
      isTableDataAvailable: true,
      inlineFilterItems,
      activeFilters: {},

      customHandlers: {
        handleClickRow: this.handleClickRow,
        handleAdd: this.handleAdd,
      },
    }
  },
  computed: {
    title() {
      return 'Vendor'
    },
    subTitle() {
      return this.$t('master.vendor.list')
    },
    apiClient() {
      let getVendor = Vendor.get

      if (Object.keys(this.activeFilters).length > 0) {
        let filters = transformFilter(this.activeFilters)
        getVendor = Vendor.getWithFilters(filters)
      }

      return {
        get: getVendor,
        delete: Vendor.deleteBulk,
      }
    },
    fields() {
      return listTableFields
    },
  },
  methods: {
    /**
     * @typedef {Object} Filter
     * @property {String} key
     * @property {String} values
     *
     * @param {Filter[]} filters
     */
    handleChangeActiveFilters(filters) {
      for (const filter of filters) {
        this.$delete(this.activeFilters, filter.key)

        if (filter.values == null) continue
        if (Array.isArray(filter.values) && filter.values.length === 0) continue

        this.$set(this.activeFilters, filter.key, filter.values)
      }
    },
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleClickRow(item) {
      this.$router.push({ name: 'Master Vendor Detail', params: { id: item.id } })
    },
    handleAdd() {
      this.$router.push({ name: 'Master Vendor Create' })
    },
    handleDeleteError(res) {
      if (res.errors) this.$mcToast.error(errorMessage(errorMessageList[res.message]))
    }
  },
}
</script>

<style lang="scss" scoped>
.page-container {
  .mc-list-header {
    margin-bottom: 24px;
  }

  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
}
</style>
